import {Component, Input} from '@angular/core';
import {NavController, NavParams} from 'ionic-angular';
import {IngredientCompCreatePreparationPage} from "../../ingredient-comp-create/ingredient-comp-create-preparation/ingredient-comp-create-preparation";


/**
 * Generated class for the IngredientViewPreparationPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-ingredient-view-preparation',
    templateUrl: 'ingredient-view-preparation.html',
})
export class IngredientViewPreparationPage {
    @Input() ingredient: any;

    constructor(public navCtrl: NavController,
                public navParams: NavParams) {
    }

    edit(){
        this.navCtrl.push(IngredientCompCreatePreparationPage, {
            update_state: true,
            ingredient_uid: this.ingredient.UID,
            recipe: this.ingredient.recipe,
            tools: this.ingredient.tools,
            time: this.ingredient.time,
            preparation: this.ingredient.preparation,
            ingredient_name: this.ingredient.name
        })
    }


}



// WEBPACK FOOTER //
// ./src/pages/ingredients/ingredient-view/ingredient-view-preparation/ingredient-view-preparation.ts